import {
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { useIsAuthenticated } from '@azure/msal-react';

import { Header } from '@/core/components/Header';
import { Sidebar } from '@/core/components/Sidebar';
import { Footer } from '@/core/components/Footer';

import {
  PageWrapper,
  SidebarMainWrapper,
  StyledMain,
} from './Layout.styles';

export type LayoutProps = {
  children: ReactNode;
  isSidebarShown?: boolean;
};

export const Layout = ({
  children,
  isSidebarShown,
}: LayoutProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };
  // window height fix for Safari
  useEffect(() => {
    const appHeight = () => {
      const doc = document.documentElement;

      doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    };

    window.addEventListener('resize', appHeight);
    appHeight();

    return () => {
      window.removeEventListener('resize', appHeight);
    };
  }, []);

  const isAuthenticated = useIsAuthenticated();

  return (
    isAuthenticated ?
      (
        <PageWrapper>
          <Header 
            isCollapsed={isSidebarShown ? isCollapsed : undefined} 
            toggleSidebar={isSidebarShown ? toggleSidebar : undefined} 
          />
          <SidebarMainWrapper>
            {isSidebarShown && (
              <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
            )}
            <StyledMain>
              {children}
            </StyledMain>
          </SidebarMainWrapper>
          <Footer />
        </PageWrapper>
      ) :
      (
        <PageWrapper>
          <SidebarMainWrapper>
            <StyledMain $ignoreMaxWidth>
              {children}
            </StyledMain>
          </SidebarMainWrapper>
          <Footer hasAlternateColor />
        </PageWrapper>
      )
  );
};
